import { render, staticRenderFns } from "./InlineLoader.vue?vue&type=template&id=284f600d&scoped=true&"
import script from "./InlineLoader.vue?vue&type=script&lang=ts&"
export * from "./InlineLoader.vue?vue&type=script&lang=ts&"
import style0 from "./InlineLoader.vue?vue&type=style&index=0&id=284f600d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f600d",
  null
  
)

export default component.exports